import { Menu, Tooltip, makeStyles } from '@material-ui/core';
import { NavigatorButton } from './NavigatorButton';
import { useNavigatorControls } from '../navigator';
import React, { Fragment, useState } from 'react';
const useStyles = makeStyles(theme => ({
    root: {
        minWidth: 200,
    },
}));
export const NavigatorMenuButton = React.forwardRef((props, ref) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const style = useStyles();
    const { navigatorState } = useNavigatorControls();
    const { text, children, ...rest } = props;
    const handleClose = () => setAnchorEl(null);
    return (React.createElement(Fragment, null,
        React.createElement(Tooltip, { title: navigatorState === 'desktop-mini' && text ? text : '', placement: "right" },
            React.createElement(NavigatorButton, Object.assign({ innerRef: ref, onClick: e => setAnchorEl(e.currentTarget) }, rest), text)),
        React.createElement(Menu, { id: "quick-add-menu", anchorEl: anchorEl, getContentAnchorEl: null, keepMounted: true, open: !!anchorEl, onClose: handleClose, onClick: handleClose, PopoverClasses: { paper: style.root }, anchorOrigin: {
                vertical: 'top',
                horizontal: 'left',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            } }, children)));
});
//# sourceMappingURL=NavigatorMenuButton.js.map